var render = function render(_c,_vm){return _c('div',{staticClass:"spinner"},[_c('svg',{attrs:{"viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"length",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"28"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }